import { DealDetailsFormValues, NewDealJourneyParams } from "../../../../models";

export const getAssociationFromSearchParams = (
  searchParams: URLSearchParams
): DealDetailsFormValues["associations"][number] | null => {
  const objectUuid = searchParams.get(NewDealJourneyParams.objectUuid);
  const objectType = searchParams.get(NewDealJourneyParams.objectType);
  const objectName = searchParams.get(NewDealJourneyParams.objectName)?.trim();

  if (!objectUuid || !objectType) return null;

  return {
    objectUuid,
    objectType,
    name: objectName ? `${objectName} | ${objectType}` : objectType,
  };
};

export const mergeAssociationIntoFormValues = (
  formValues: DealDetailsFormValues,
  association: DealDetailsFormValues["associations"][number] | null
): DealDetailsFormValues => {
  if (!association) return formValues;

  const exists = formValues.associations.some(
    (value) => value.objectUuid === association.objectUuid && value.objectType === association.objectType
  );

  if (exists) return formValues;

  return {
    ...formValues,
    selectedInvestedInto: formValues.selectedInvestedInto ?? "Project(s)",
    associations: [...formValues.associations, association],
  };
};
